import { ELogType } from '../types';
import { getLogConfigMapFunc } from './interfaces';

export const getLogConfigMap: getLogConfigMapFunc = (t) => {
  return {
    [ELogType.WORKER_AUTHORIZED_FROM_BILLING]: {
      title: t('log.auth'),
      iconName: 'SignInIcon',
      color: 'white',
    },
    [ELogType.CLIENT_AUTHORIZED_FROM_HOST]: {
      title: t('log.auth'),
      iconName: 'SignInIcon',
      color: 'white',
    },
    [ELogType.WORKER_AUTHORIZED_FROM_HOST]: {
      title: t('log.auth'),
      iconName: 'SignInIcon',
      color: 'white',
    },

    [ELogType.USER_REGISTERED]: {
      title: t('log.register'),
      iconName: 'AddUserIcon',
      color: 'white',
    },
    [ELogType.USER_BANNED]: {
      title: t('log.banned'),
      iconName: 'BlockUserIcon',
      color: 'red',
    },
    [ELogType.USER_UNBANNED]: {
      title: t('log.unbanned'),
      iconName: 'UserFriendlyIcon',
      color: 'green',
    },
    [ELogType.USER_RESET_PASSWORD]: {
      title: t('log.user.password.changed'),
      iconName: 'ClosedEyeIcon',
      color: 'white',
    },
    [ELogType.USER_DISCOUNT_UPDATED]: {
      title: t('log.user.discount.changed'),
      iconName: 'EditIcon',
      color: 'orange',
    },
    [ELogType.BONUS_PAYMENT_CREATED]: {
      title: t('log.bonus.create'),
      iconName: 'BonusIcon',
      color: 'white',
    },
    [ELogType.DEPOSIT_UPDATED]: {
      title: t('log.deposit.update'),
      iconName: 'EditIcon',
      color: 'orange',
    },
    [ELogType.DEPOSIT_ADDED_ONLINE]: {
      title: t('log.deposit.added_online'),
      iconName: 'CashbackIcon',
      color: 'white',
    },

    [ELogType.SEND_VERIFY_CODE]: {
      title: t('log.send.verify_code'),
      iconName: 'CodeIcon',
      color: 'white',
    },
    [ELogType.SEND_RESET_CODE]: {
      title: t('log.send.reset_code'),
      iconName: 'CodeIcon',
      color: 'white',
    },

    [ELogType.WORKER_CREATED]: {
      title: t('log.worker.created'),
      iconName: 'HiredIcon',
      color: 'orange',
    },
    [ELogType.WORKER_UPDATED]: {
      title: t('log.worker.updated'),
      iconName: 'EditIcon',
      color: 'orange',
    },
    [ELogType.WORKER_ENABLED]: {
      title: t('log.banned'),
      iconName: 'BlockUserIcon',
      color: 'green',
    },
    [ELogType.WORKER_DELETED]: {
      title: t('log.worker.deleted'),
      iconName: 'FiredIcon',
      color: 'red',
    },

    [ELogType.WORK_SHIFT_STARTED]: {
      title: t('log.work_shift.started'),
      iconName: 'StartIcon',
      color: 'blue',
    },
    [ELogType.WORK_SHIFT_FINISHED]: {
      title: t('log.work_shift.finished'),
      iconName: 'FinishIcon',
      color: 'blue',
    },

    [ELogType.HOST_GROUP_CREATED]: {
      title: t('log.host_group.created'),
      iconName: 'MapIcon',
      color: 'white',
    },
    [ELogType.HOST_GROUP_DELETED]: {
      title: t('log.host_group.deleted'),
      iconName: 'BucketIcon',
      color: 'red',
    },

    [ELogType.HOST_CREATED]: {
      title: t('log.host.created'),
      iconName: 'ComputerIcon',
      color: 'white',
    },
    [ELogType.HOST_SWITCHED_GROUP]: {
      title: t('log.host.switched_group'),
      iconName: 'MoveIcon',
      color: 'orange',
    },

    [ELogType.HOST_SESSION_STARTED]: {
      title: t('log.host.started'),
      iconName: 'ShutdownIcon',
      color: 'white',
    },
    [ELogType.HOST_SESSION_FINISHED]: {
      title: t('log.host.finished'),
      iconName: 'ShutdownIcon',
      color: 'white',
    },

    [ELogType.SEND_HOST_COMMAND]: {
      title: t('log.host.send_command'),
      iconName: 'TerminalIcon',
      color: 'white',
    },

    [ELogType.SHELL_HIGH_ACCESS_ENABLED]: {
      title: t('log.shell.high_access'),
      iconName: 'TechModeIcon',
      color: 'orange',
    },
    [ELogType.SHELL_HIGH_ACCESS_DISABLED]: {
      title: t('log.shell.high_access'),
      iconName: 'TechModeIcon',
      color: 'green',
    },

    [ELogType.SHELL_DISABLED]: {
      title: t('log.shell.disabled'),
      iconName: 'AlertIcon',
      color: 'red',
    },
    [ELogType.SHELL_ENABLED]: {
      title: t('log.shell.enabled'),
      iconName: 'SuccessIcon',
      color: 'green',
    },

    [ELogType.CLIENT_SESSION_STARTED]: {
      title: t('log.client_session.started'),
      iconName: 'StartIcon',
      color: 'white',
    },
    [ELogType.CLIENT_SESSION_UNPAUSED]: {
      title: t('log.client_session.unpause'),
      iconName: 'StartIcon',
      color: 'white',
    },
    [ELogType.CLIENT_SESSION_UNPAUSED_AUTO]: {
      title: t('log.client_session.unpause'),
      iconName: 'StartIcon',
      color: 'white',
    },
    [ELogType.CLIENT_SESSION_PROLONGED]: {
      title: t('log.client_session.prolonged'),
      iconName: 'RenewalIcon',
      color: 'white',
    },
    [ELogType.CLIENT_SESSION_FINISHED]: {
      title: t('log.client_session.finished'),
      iconName: 'StopIcon',
      color: 'white',
    },
    [ELogType.CLIENT_SESSION_PAUSED]: {
      title: t('log.client_session.paused'),
      iconName: 'PauseIcon',
      color: 'white',
    },
    [ELogType.CLIENT_SESSION_HOST_CHANGED]: {
      title: t('log.client_session.host_changed'),
      iconName: 'LeftRightArrowsIcon',
      color: 'white',
    },
    [ELogType.HOST_PUNISHED]: {
      title: t('log.client_session.punished'),
      iconName: 'TimeDownIcon',
      color: 'red',
    },

    [ELogType.PAYMENT_CREATED]: {
      title: t('log.payment.created'),
      iconName: 'ShopIcon',
      color: 'white',
    },
    [ELogType.PAYMENT_REFUND]: {
      title: t('log.payment.refund'),
      iconName: 'ErrorIcon',
      color: 'red',
    },

    [ELogType.TARIFF_CREATED]: {
      title: t('log.tariff.created'),
      iconName: 'TariffIcon',
      color: 'white',
    },
    [ELogType.TARIFF_UPDATED]: {
      title: t('log.tariff.updated'),
      iconName: 'EditIcon',
      color: 'orange',
    },
    [ELogType.TARIFF_DELETED]: {
      title: t('log.tariff.deleted'),
      iconName: 'BucketIcon',
      color: 'red',
    },

    [ELogType.GOOD_CREATED]: {
      title: t('log.good.created'),
      iconName: 'BarCodeIcon',
      color: 'white',
    },
    [ELogType.GOOD_UPDATED]: {
      title: t('log.good.updated'),
      iconName: 'EditIcon',
      color: 'orange',
    },
    [ELogType.GOOD_DELETED]: {
      title: t('log.good.deleted'),
      iconName: 'BucketIcon',
      color: 'red',
    },

    [ELogType.WAREHOUSE_GOODS_DISPOSED]: {
      title: t('log.warehouse_goods.disposed'),
      iconName: 'FailedPaymentIcon',
      color: 'white',
    },
    [ELogType.WAREHOUSE_GOODS_ADDED]: {
      title: t('log.warehouse_goods.added'),
      iconName: 'CirclePlusIcon',
      color: 'white',
    },

    [ELogType.SERVICE_CREATED]: {
      title: t('log.service.created'),
      iconName: 'PrinterIcon',
      color: 'white',
    },
    [ELogType.SERVICE_UPDATED]: {
      title: t('log.service.updated'),
      iconName: 'EditIcon',
      color: 'orange',
    },
    [ELogType.SERVICE_DELETED]: {
      title: t('log.service.deleted'),
      iconName: 'BucketIcon',
      color: 'red',
    },

    [ELogType.DISCOUNT_CREATED]: {
      title: t('log.discount.created'),
      iconName: 'PercentIcon',
      color: 'white',
    },
    [ELogType.DISCOUNT_UPDATED]: {
      title: t('log.discount.updated'),
      iconName: 'EditIcon',
      color: 'orange',
    },
    [ELogType.DISCOUNT_DELETED]: {
      title: t('log.discount.deleted'),
      iconName: 'BucketIcon',
      color: 'red',
    },

    [ELogType.PROMO_CODE_CREATED]: {
      title: t('log.promo.created'),
      iconName: 'PercentIcon',
      color: 'white',
    },
    [ELogType.PROMO_CODE_UPDATED]: {
      title: t('log.promo.updated'),
      iconName: 'EditIcon',
      color: 'orange',
    },
    [ELogType.PROMO_CODE_DELETED]: {
      title: t('log.promo.deleted'),
      iconName: 'BucketIcon',
      color: 'red',
    },

    [ELogType.PROMO_CODE_USED]: {
      title: t('log.promo.used'),
      iconName: 'CheckIcon',
      color: 'white',
    },
    [ELogType.PROMO_CODE_EXPIRED]: {
      title: t('log.promo.expired'),
      iconName: 'AlertIcon',
      color: 'orange',
    },
    [ELogType.PROMO_CAMPAIGN_CREATED]: {
      title: t('log.promo_campaign.create'),
      iconName: 'PercentIcon',
      color: 'white',
    },
    [ELogType.PROMO_CAMPAIGN_UPDATED]: {
      title: t('log.promo_campaign.update'),
      iconName: 'EditedIcon',
      color: 'orange',
    },
    [ELogType.PROMO_CAMPAIGN_DELETED]: {
      title: t('log.promo_campaign.delete'),
      iconName: 'BucketIcon',
      color: 'red',
    },
    [ELogType.PROMO_CAMPAIGN_CODES_GENERATED]: {
      title: t('log.promo_campaign.generate'),
      iconName: 'EditedIcon',
      color: 'orange',
    },
    [ELogType.PROMO_CAMPAIGN_EXPIRED]: {
      title: t('log.promo_campaign.expired'),
      iconName: 'AlertIcon',
      color: 'orange',
    },

    [ELogType.CASH_ORDER_CREATED]: {
      title: t('log.cash_order.created'),
      iconName: 'ListIcon',
      color: 'white',
    },

    [ELogType.HOST_HARDWARE_CHANGED]: {
      title: t('log.host_hardware.changed'),
      iconName: 'ServerIcon',
      color: 'orange',
    },
    [ELogType.HOST_HARDWARE_APPLIED]: {
      title: t('log.host_hardware.applied'),
      iconName: 'ServerIcon',
      color: 'green',
    },

    [ELogType.CLUB_CREATED]: {
      title: t('log.club.created'),
      iconName: 'HouseIcon',
      color: 'white',
    },

    [ELogType.TELEGRAM_LINKED]: {
      title: t('log.telegram.linked'),
      iconName: 'PaperPlaneIcon',
      color: 'white',
    },
    [ELogType.TELEGRAM_UNLINKED]: {
      title: t('log.telegram.unlinked'),
      iconName: 'PaperPlaneIcon',
      color: 'white',
    },

    [ELogType.TASK_ADDED]: {
      title: t('log.task.added'),
      iconName: 'EditIcon',
      color: 'white',
    },

    [ELogType.HOST_ADMIN_CALLED]: {
      title: t('log.host_admin.called'),
      iconName: 'CallAdminIcon',
      color: 'orange',
    },
    [ELogType.HOST_ADMIN_CALL_CHECKED]: {
      title: t('log.host_admin.call_checked'),
      iconName: 'CallAdminIcon',
      color: 'green',
    },
    [ELogType.HOST_ADMIN_CALL_FAILED]: {
      title: t('log.host_admin.call_failed'),
      iconName: 'CallAdminIcon',
      color: 'red',
    },
    [ELogType.CLUB_COMMENT_CREATED]: {
      title: t('log.club_comment.created'),
      iconName: 'CommentIcon',
      color: 'white',
    },
    [ELogType.ACHIEVEMENT_CREATED]: {
      title: t('log.achievement.created'),
      iconName: 'AchievementsIcon',
      color: 'white',
    },
    [ELogType.ACHIEVEMENT_DELETED]: {
      title: t('log.achievement.deleted'),
      iconName: 'BucketIcon',
      color: 'red',
    },
    [ELogType.ACHIEVEMENT_ASSIGNED]: {
      title: t('log.achievement.assigned'),
      iconName: 'AchievementsIcon',
      color: 'green',
    },
    [ELogType.BOOKING_CREATED]: {
      title: t('log.booking.created'),
      iconName: 'MonitorArrowInIcon',
      color: 'white',
    },
    [ELogType.BOOKING_CANCELED]: {
      title: t('log.booking.canceled'),
      iconName: 'MonitorArrowInIcon',
      color: 'red',
    },
    [ELogType.BOOKING_FAILED_TO_START]: {
      title: t('log.booking.failed'),
      iconName: 'MonitorArrowInIcon',
      color: 'red',
    },
    [ELogType.BOOKING_UPDATED]: {
      title: t('log.booking.updated'),
      iconName: 'MonitorArrowInIcon',
      color: 'orange',
    },
    [ELogType.BOOKING_CONFIRMED]: {
      title: t('log.booking.confirmed'),
      iconName: 'MonitorArrowInIcon',
      color: 'green',
    },
    [ELogType.COMBO_CREATED]: {
      title: t('combo.creating'),
      iconName: 'ShopIcon',
      color: 'white',
    },
    [ELogType.COMBO_UPDATED]: {
      title: t('combo.editing'),
      iconName: 'EditIcon',
      color: 'orange',
    },
    [ELogType.COMBO_DELETED]: {
      title: t('combo.deleting'),
      iconName: 'BucketIcon',
      color: 'red',
    },
    [ELogType.POST_PAYMENT_CANCELED]: {
      title: t('log.payment.cancel'),
      iconName: 'CircleCloseIcon',
      color: 'red',
    },
    [ELogType.DEBT_ACTIVATED]: {
      title: t('log.payment.debt.activate'),
      iconName: 'WalletIcon',
      color: 'green',
    },
    [ELogType.SETTINGS_UPDATED]: {
      title: t('log.settings.edit'),
      iconName: 'EditIcon',
      color: 'orange',
    },
    [ELogType.USER_GROUP_CREATED]: {
      title: t('log.client_group.created'),
      iconName: 'GroupIcon',
      color: 'white',
    },
    [ELogType.USER_GROUP_UPDATED]: {
      title: t('log.client_group.updated'),
      iconName: 'EditIcon',
      color: 'orange',
    },
    [ELogType.USER_GROUP_DELETED]: {
      title: t('log.client_group.deleted'),
      iconName: 'GroupIcon',
      color: 'red',
    },
    [ELogType.USER_CHANGED_GROUP]: {
      title: t('log.client_group'),
      iconName: 'GroupIcon',
      color: 'orange',
    },
    [ELogType.BONUS_UPDATED]: {
      title: t('log.bonus.update'),
      iconName: 'EditIcon',
      color: 'orange',
    },
    [ELogType.GOOD_LOW_STOCK_THRESHOLD_REACHED]: {
      title: t('log.discount.good_low_stock_threshold_reached'),
      iconName: 'BarCodeIcon',
      color: 'orange',
    },
    [ELogType.GOOD_CATEGORY_CREATED]: {
      title: t('log.discount.good_group.created'),
      iconName: 'GoodsGroupIcon',
      color: 'white',
    },
    [ELogType.GOOD_CATEGORY_UPDATED]: {
      title: t('log.discount.good_group.updated'),
      iconName: 'EditIcon',
      color: 'orange',
    },
    [ELogType.GOOD_CATEGORY_DELETED]: {
      title: t('log.discount.good_group.deleted'),
      iconName: 'BucketIcon',
      color: 'red',
    },
    [ELogType.USER_DEPOSIT_TRANSFERRED]: {
      title: t('reports.table.transfers'),
      iconName: 'WalletArrowLeftIcon',
      color: 'white',
    },
    [ELogType.BONUS_UPDATED]: {
      title: t('log.bonus.update'),
      iconName: 'EditIcon',
      color: 'orange',
    },
    [ELogType.USER_VERIFIED]: {
      title: t('log.user.verified'),
      iconName: 'CheckIcon',
      color: 'green',
    },
    [ELogType.NEWS_CREATED]: {
      title: t('logs.news.create'),
      iconName: 'AppsIcon',
      color: 'white',
    },
    [ELogType.NEWS_UPDATED]: {
      title: t('logs.news.update'),
      iconName: 'EditIcon',
      color: 'orange',
    },
    [ELogType.NEWS_DELETED]: {
      title: t('logs.news.delete'),
      iconName: 'BucketIcon',
      color: 'red',
    },
    [ELogType.HOST_QR_GENERATE]: {
      title: t('logs.host.generate'),
      iconName: 'QRCodeIcon',
      color: 'white',
    },
    [ELogType.SHORTCUT_CREATED]: {
      title: t('logs.app.create'),
      iconName: 'AppsIcon',
      color: 'white',
    },
    [ELogType.SHORTCUT_UPDATED]: {
      title: t('logs.app.update'),
      iconName: 'AppsIcon',
      color: 'orange',
    },
    [ELogType.SHORTCUT_DELETED]: {
      title: t('logs.app.delete'),
      iconName: 'AppsIcon',
      color: 'red',
    },
    [ELogType.SETTINGS_COPIED]: {
      title: t('log.SETTINGS_COPIED'),
      iconName: 'GearIcon',
      color: 'white',
    },
    [ELogType.ADVERTISEMENT_MANUAL_COMPLETED]: {
      title: t('log.ADVERTISEMENT_MANUAL_COMPLETED'),
      iconName: 'EyeNoIcon',
      color: 'white',
    },
    [ELogType.ADVERTISEMENT_APPROVED]: {
      title: t('log.ADVERTISEMENT_APPROVED'),
      iconName: 'CheckIcon',
      color: 'green',
    },
    [ELogType.ADVERTISEMENT_REJECTED]: {
      title: t('log.ADVERTISEMENT_APPROVED'),
      iconName: 'CheckIcon',
      color: 'red',
    },
    [ELogType.ADVERTISEMENT_MODERATION]: {
      title: t('log.ADVERTISEMENT_MODERATION'),
      iconName: 'RowCellIcon',
      color: 'white',
    },
  };
};
